var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGammaIcon = function SvgGammaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gamma-icon_svg__filter0_d_20773_28047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1859 13.232C12.8556 13.5623 12.3202 13.5623 11.9899 13.232L8.8134 10.0555V12.5816C8.8134 13.0487 8.43473 13.4272 7.96773 13.4272C7.50066 13.4272 7.12207 13.0487 7.12207 12.5816V10.081L5.39092 11.8121C5.06068 12.1424 4.52528 12.1424 4.19501 11.8122C3.86475 11.482 3.8647 10.9464 4.19496 10.6162L5.9757 8.83545H3.43892C2.97193 8.83545 2.59326 8.45689 2.59326 7.98979C2.59326 7.52276 2.97189 7.14412 3.43892 7.14412H5.90201L2.74769 3.98979C2.41744 3.65953 2.41744 3.12409 2.74769 2.79384C3.07791 2.46362 3.61339 2.46362 3.94361 2.79384L7.12207 5.97229V3.36618C7.12207 2.89919 7.50062 2.52052 7.96773 2.52052C8.43477 2.52052 8.8134 2.89915 8.8134 3.36618V5.99774L10.7112 4.09991C11.0414 3.76982 11.5769 3.76958 11.9072 4.0999C12.2374 4.43016 12.2374 4.9656 11.9072 5.29586L10.0589 7.14412H12.6543C13.1214 7.14412 13.5 7.52275 13.5 7.98979C13.5 8.4569 13.1213 8.83545 12.6543 8.83545H9.98523L13.1859 12.0361C13.5161 12.3663 13.5161 12.9018 13.1859 13.232Z",
    fill: "#E4E4EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gamma-icon_svg__filter0_d_20773_28047",
    x: -2,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20773_28047"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_20773_28047",
    result: "shape"
  })))));
};
export default SvgGammaIcon;